// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","password":"login_password__65fka","contact":"login_contact__VAaVc"};